/**
 * The SharePoint pages the support affordances point at.
 *
 * Shared so the old page header's dropdown and the redesigned side nav cannot
 * drift while both exist. The header's copy goes when the old project list does.
 */
export const TRAINING_URL =
  'https://aecom.sharepoint.com/sites/VivaEcoAI4Eng/SitePages/Training.aspx';

export const SUPER_USERS_URL =
  'https://aecom.sharepoint.com/sites/VivaEcoAI4Eng/SitePages/Super-Users.aspx';
